/**
 * One colour per person, painted on their Account tiles, charts and owner
 * chips. Taken from the family's own BudgetBakers Wallet (read 2026-09-25) so
 * a tile looks the same colour in AIM as it did in Wallet; Mom had no Wallet
 * colour and was given orange.
 */
export const PERSON_COLORS = {
  Ankit: "#0D47A1",
  Pritesh: "#00695C",
  Rinky: "#BA68C8",
  Spriha: "#D32F2F",
  Mom: "#EF6C00",
  Maira: "#9E9E9E",
  Anokhi: "#F59E0B",
  Jiyaan: "#14B8A6",
} as const;

export function getDefaultColor(userName: string): string {
  const first = (userName ?? "").trim().split(/\s+/)[0] ?? "";
  return (PERSON_COLORS as Record<string, string>)[first] ?? "#64748b";
}
